import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Amount } from '@shared/components/styled/amount';
import ArrowUp from '@mui/icons-material/ArrowUpward';
import ArrowDown from '@mui/icons-material/ArrowDownward';
import Decimal from 'decimal.js';
const AggregatedAmount = (props) => {
    const theme = useTheme();
    return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
        React.createElement(Typography, { variant: 'caption' }, props.label),
        React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
            props.type === 'incoming' ? React.createElement(ArrowDown, { color: 'success' }) : React.createElement(ArrowUp, { color: 'error' }),
            React.createElement(Amount, { size: '18', textColor: props.type === 'incoming' ? theme.palette.success.main : theme.palette.error.main },
                props.settlements
                    .filter((s) => s.direction === props.direction && (props.selectedOnly ? s.selected : true))
                    .map((m) => m.amountToSettle)
                    .reduce((a, b) => a.plus(new Decimal(b)), new Decimal(0))
                    .toString(),
                "\u00A0",
                props.currency.toUpperCase()))));
};
export default AggregatedAmount;
